import { Directive, HostListener, Input, OnInit, OnDestroy, ElementRef, Renderer2 } from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';

@Directive({
    selector: '[appOffClick]',
    standalone: false
})
export class OffClickDirective implements OnInit, OnDestroy {
  // tslint:disable-next-line:no-input-rename
  @Input('appOffClick') public offClickHandler: any;
  clickSubscription: Subscription;
  keySubscription: Subscription;
  
  constructor(public elementRef: ElementRef, private renderer: Renderer2) { }
  
  @HostListener('click', ['$event'])
  public onClick($event: MouseEvent): void {
    // $event.stopPropagation();
  }
  
  @HostListener('keydown', ['$event'])
  onkeydown(event: KeyboardEvent) {
    if (event.keyCode === 17 || event.keyCode === 112) {
      this.offClickHandler();
    }
  }
  
  public ngOnInit(): any {
    setTimeout(() => {
      this.clickSubscription = fromEvent(document, 'click').subscribe((event: MouseEvent) => {
        // event.preventDefault();
        // event.stopImmediatePropagation();
        // event.stopPropagation();
        
        // Replace jQuery closest check with native DOM method
        const target = event.target as Node;
        if (!this.elementRef.nativeElement.contains(target)) {
          this.offClickHandler();
        }
      });
    }, 0);
  }
  
  public ngOnDestroy(): any {
    if (this.clickSubscription) {
      this.clickSubscription.unsubscribe();
    }
  }
}